import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56349138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table gy-4 min-w-850px" }
const _hoisted_3 = { class: "w-32" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'card mb-5 card-drawer': _ctx.showCard })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'card-body': _ctx.showCard })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (items, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, ({ header, headerClass, value, valueClass, isHTML, slot }, innerIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: innerIndex }, [
                  _createElementVNode("th", {
                    class: _normalizeClass([headerClass, "d-flex break-word"])
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(header) + _toDisplayString(_ctx.separator), 1)
                  ], 2),
                  _createElementVNode("td", _hoisted_3, [
                    (!slot)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([valueClass, "d-inline-block break-word"])
                        }, [
                          (!isHTML)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (header != 'Address')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(value && value.length > 30
                          ? value.slice(0, 29) + "..."
                          : value), 1))
                                  : _createCommentVNode("", true),
                                (header == 'Address')
                                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, [
                                      _createTextVNode(_toDisplayString(value && value.length > 30
                          ? value.slice(0, 29) + "..."
                          : value), 1)
                                    ])), [
                                      [_directive_tippy, {
                        allowHTML: true,
                        interactive: true,
                        content: `<div id='tootip-element' class='tooltip-content'>${value} 
                                    <a
                                    id='copyIcon'
                                    onclick='calltheFunction(event)'
                                    class='fas fa-copy fs-5 cursor-pointer' 
                                    style='margin-left: 10px;'></a>
                            </div>`,
                      }]
                                    ])
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: value
                              }, null, 8, _hoisted_6))
                        ], 2))
                      : _renderSlot(_ctx.$slots, slot, { key: 1 }, undefined, true)
                  ])
                ], 64))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ], 2))
}